var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActLess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 13,
    viewBox: "0 0 22 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "act_less",
    d: "M0.961846 9.91565L0.961868 9.91562L8.98234 1.91183C10.0316 0.862566 11.7389 0.862689 12.7886 1.91241L20.8085 9.91562L20.5436 10.1811L20.8085 9.91563C21.033 10.1397 21.1454 10.4343 21.1454 10.7277C21.1454 11.0203 21.0337 11.3143 20.8102 11.5382C20.3626 11.9866 19.6362 11.9874 19.1877 11.5398L19.1877 11.5398L11.167 3.53575L11.1667 3.53548C11.0113 3.38005 10.7588 3.38042 10.6043 3.5349L10.604 3.53518L2.58268 11.5398L2.58267 11.5398C2.13417 11.9874 1.40779 11.9866 0.960217 11.5381L0.961846 9.91565ZM0.961846 9.91565C0.513368 10.3633 0.512624 11.0896 0.960183 11.5381L0.961846 9.91565Z",
    fill: "#1E3799",
    stroke: "#1E3799",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActLess);
export default __webpack_public_path__ + "static/media/act_less.8e30941fb51ffea76a26e0a80aaaaf37.svg";
export { ForwardRef as ReactComponent };